import Icon from '@dtvgo/icon';
import MenuButton from '../MenuButton/MenuButton.js';
import AudioSubtitlesMenuContent from '../AudioSubtitlesMenuContent/AudioSubtitlesMenuContent.js';
import './AudioSubtitleButton.scss';
import { jsx } from 'react/jsx-runtime';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/createSuper';
import 'react';
import '../PlayerButton/PlayerButton.js';
import '../PlayerButton/PlayerButton.scss';
import '../ConditionalVisible/ConditionalVisible.js';
import '@babel/runtime/helpers/esm/objectSpread2';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@dtvgo/classnames';
import '../ConditionalVisible/ConditionalVisible.scss';
import '../MenuButton/MenuButton.scss';
import '../TracksMenu/TracksMenu.js';
import '../TracksMenu/TracksMenu.scss';
import '../SubtitleTracksMenu/SubtitleTracksMenu.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import 'lodash/some';
import '../AudioSubtitlesMenuContent/AudioSubtitlesMenuContent.scss';

/* External */

function AudioSubtitleButton(_ref) {
  var audioTracks = _ref.audioTracks,
    onSelectAudio = _ref.onSelectAudio,
    subtitleTracks = _ref.subtitleTracks,
    onSelectSubtitle = _ref.onSelectSubtitle,
    onDisableSubtitles = _ref.onDisableSubtitles,
    tooltip = _ref.tooltip,
    subtitlesTitle = _ref.subtitlesTitle,
    audioTitle = _ref.audioTitle,
    getLanguageLabel = _ref.getLanguageLabel;
  return /*#__PURE__*/jsx(MenuButton, {
    buttonContent: /*#__PURE__*/jsx(Icon, {
      name: "subtitles"
    }),
    className: "dtv-common-c-audio-subtitle-button",
    tooltip: tooltip,
    children: /*#__PURE__*/jsx(AudioSubtitlesMenuContent, {
      audioTracks: audioTracks,
      onSelectAudio: onSelectAudio,
      subtitleTracks: subtitleTracks,
      onSelectSubtitle: onSelectSubtitle,
      onDisableSubtitles: onDisableSubtitles,
      audioTitle: audioTitle,
      subtitlesTitle: subtitlesTitle,
      getLanguageLabel: getLanguageLabel
    })
  });
}
AudioSubtitleButton.defaultProps = {
  audioTracks: [],
  onSelectAudio: function onSelectAudio() {},
  subtitleTracks: [],
  onSelectSubtitle: function onSelectSubtitle() {},
  onDisableSubtitles: function onDisableSubtitles() {},
  tooltip: '',
  subtitlesTitle: '',
  audioTitle: '',
  getLanguageLabel: function getLanguageLabel() {}
};

export { AudioSubtitleButton as default };
//# sourceMappingURL=AudioSubtitleButton.js.map
